import { Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../services/auth.service';
import { SegmentedInputComponent } from "../../shared/segmented-input/segmented-input.component";
import { NetworkStatusBadgeComponent } from "../../shared/network-status-badge/network-status-badge.component";
import { RuntimeService } from '../../shared/services/runtime.service';
import { NetworkStatusService } from '../../shared/services/network-status.service';
import { APP_VERSION } from '../../../environments/version';

@Component({
  selector: 'app-verify-licence',
  imports: [CommonModule, FormsModule, SegmentedInputComponent, NetworkStatusBadgeComponent],
  templateUrl: './verify-licence.component.html',
  styleUrl: './verify-licence.component.scss'
})
export class VerifyLicenceComponent {

  licenceKey = '';
  errorMessage = '';
  appVersion = APP_VERSION;
  isOnline: Signal<boolean>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    protected runtime: RuntimeService,
    private networkStatus: NetworkStatusService
  ) {
    this.isOnline = toSignal(this.networkStatus.isOnline$, {
      initialValue: this.networkStatus.isOnline,
    });
  }

  activateLicence() {
    if (!this.licenceKey || !this.isOnline()) return;

    this.errorMessage = '';
    this.spinner.show();

    this.authService.validateLicence(this.licenceKey).subscribe({
      next: (res) => {
        this.spinner.hide();
        console.log("here the validateLicense");
        
        const licenceData = res?.data ?? res;
        if (licenceData?.valid) {
          console.log('stored license');
          
          this.authService.storeLicence(this.licenceKey);
          this.router.navigate(['/login'], {
            state: {
              toast: {
                type: 'success',
                title: 'Success',
                message: licenceData?.message || res?.message || 'License activated successfully',
              },
            },
          });
        } else {
          this.errorMessage = licenceData?.message || res?.message || 'License validation failed.';
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.errorMessage = err?.error?.message || 'Unable to validate license. Please try again.';
      }
    });
  }

  deleteLicence() {
    this.authService.deleteLicence();
  }
}
